import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout/index";
import AccountSetting from "../pages/setting/Account/AccountSetting.tsx";
import EmployeeUpdate from "../pages/setting/Account/EmployeeUpdate.tsx";
import CompanySetting from "../pages/setting/Client/CompanySetting.tsx";
import EmailDomainSetting from "../pages/setting/EmailDomain/EmailDomainSetting.tsx";
import AiUsageSetting from "../pages/setting/AiUsage/AiUsageSetting.tsx";
import OwnerRoute from "./OwnerRoute.tsx";
import BillingList from "../pages/setting/Billing/BillingList.tsx";
import BillingPdfView from "../pages/setting/Billing/BillingPdfView.tsx";
import PrivateRoute from "./PrivateRoute.tsx";
import Login from "../pages/auth/Login";
import CheckMail from "../pages/auth/CheckMail";
import Otp from "../pages/auth/Otp";
import ResetSuccess from "../pages/auth/ResetSuccess";
import ChangePassword from "../pages/auth/ChangePassword";
import NotFound from "@/pages/404/NotFound.tsx";
// import { logoJpg as logosrc } from "@ippon/shared-assets";
const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Public login */}
      <Route path="/login" element={<Login />} />
      {/* Forgot password - check mail */}
      <Route path="/checkmail" element={<CheckMail />} />
      {/* OTP */}
      <Route path="/otp" element={<Otp />} />
      {/* Reset Success */}
      <Route path="/reset-success" element={<ResetSuccess />} />
      {/* Change Password (Email link flow) */}
      <Route path="/reset_password" element={<ChangePassword />} />
      {/* Protected routes under MainLayout */}
      <Route element={<PrivateRoute />}>
        {/* 請求書PDFのみ全画面表示（ヘッダー・サイドバー無し）。請求一覧のPDF表示ボタンから新規タブで開く */}
        <Route element={<OwnerRoute />}>
          <Route path="/setting/billing/:id/pdf" element={<BillingPdfView />} />
        </Route>
        <Route path="/" element={<MainLayout />}>
          <Route index element={null} />
          {/* 設定 */}
          <Route path="setting/account" element={<AccountSetting />} />
          <Route
            path="setting/account/:employee_id"
            element={<EmployeeUpdate />}
          />
          <Route path="setting/company" element={<CompanySetting />} />
          <Route path="setting/email-domain" element={<EmailDomainSetting />} />
          {/* 利用状況・請求はオーナー専用（サイドバーからも非表示） */}
          <Route element={<OwnerRoute />}>
            <Route path="setting/ai-usage" element={<AiUsageSetting />} />
            {/* 請求一覧（請求書PDFは別タブの /setting/billing/:id/pdf で表示する） */}
            <Route path="setting/billing" element={<BillingList />} />
          </Route>
        </Route>
      </Route>

      {/* 404 fallback */}
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRouter;
